var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLodgin = function SvgLodgin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.75 6.925V21a1.5 1.5 0 0 1-1.5 1.5h-7.5a1.5 1.5 0 0 1-1.5-1.5v-5.285a3 3 0 0 1 .88-2.125L7.735 8a1.74 1.74 0 0 0 0-2.47 1.75 1.75 0 0 0-3 1.24 1.65 1.65 0 0 1-.81 1.5 1.77 1.77 0 0 1-2.69-1.5 5.255 5.255 0 0 1 5.36-5.27 5.365 5.365 0 0 1 5.155 5.425"
  })));
};
export default SvgLodgin;